import React, { Children, Component } from "react";
import { Button, Spinner, Tip } from "modules/theme";
import { Link } from "react-router-dom";
import { injectGlobal } from "styled-components";

injectGlobal`

    .fixed-filter-btn {
        position: absolute !important;
        right:0;
        top:22px;
    }
`;

export class ButtonCommonTheme extends Component {
  render() {
    const {
      type,
      disabled,
      btnType,
      size,
      btnStyle,
      style,
      modalBtnTitle,
      className,
      OnClick,
      onClick,
      children,
      filterOnClick,
      downloadOnClick,
      customTop,
      downloadState,
      editOnClick,
      manageAgentOnClick,
      manageTeamLeaderOnClick,
      deleteOnClick,
      checkboxDeleteOnClick,
      addOnClick,
      name,
      icon,
      defaultPhonenumberOnClick,
      rateTo,
      infoOnClick,
      playButtonOnClick,
      pauseButtonOnClick,
      editColumnsOnClick,
      editLink,
      churnContactOnClick,
      manageCampaignOnClick,
      importExportDownloadOnClick,
      importExportFileURL,
      addLink,
      pauseLinkButtonOnClick,
      playLinkButtonOnClick,
      countCampaignOnClick,
      countCampaignValue,
      removeLinkBtnOnClick,
      addLinkBtnOnClick,
      integrationLink,
      btnTitle,
      isLoading = false,
      title,
      ...props
    } = this.props;
    if (type === "editColumns") {
      return (
        <Button
          className="lightbutton-btn"
          btnStyle="simple"
          size="small"
          onClick={editColumnsOnClick}
          {...props}
        >
          <span className="material-symbols-outlined">edit</span>
          <div className="btn-label remove-text-on-925px">Edit columns</div>
        </Button>
      );
    } else if (type === "filter") {
      return (
        <Button
          btnStyle="filter"
          size="small"
          onClick={filterOnClick}
          className={`darkblue-btn right-side-filter fixed-filter-btn ${className}`}
          style={{ padding: "8px 10px", ...style }}
        >
          <span className="material-symbols-outlined"> Tune </span>
          <div
            className="btn-label remove-text-on-925px"
            style={{
              lineHeight: "16px",
              textTransform: "capitalize",
            }}
          >
            Filter
          </div>
        </Button>
      );
    } else if (type === "disableDownload") {
      return (
        <Button
          className="lightbutton-btn"
          btnStyle="default"
          size="small"
          disabled="true"
          style={{}}
          // onClick={this.downloadReport}
          onClick={downloadOnClick}
        >
          {downloadState ? (
            <Spinner
              style={{
                height: "3px",
                marginTop: "-15px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
          ) : (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="material-symbols-outlined">download</span>
              <div className="btn-label">Download</div>
            </div>
          )}
        </Button>
      );
    } else if (type === "download") {
      return (
        <Button
          className="lightbutton-btn"
          btnStyle="default"
          size="small"
          style={style}
          onClick={downloadOnClick}
          {...props}
        >
          {downloadState ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Spinner
                style={{
                  height: "3px",
                  marginTop: "-15px",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              />
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="material-symbols-outlined">download</span>
              <div className="btn-label remove-text-on-925px">Download</div>
            </div>
          )}
        </Button>
      );
    } else if (type === "add") {
      return (
        <Button
          btnStyle="default"
          size="small"
          className="lightbutton-btn"
          onClick={addOnClick}
          disabled={disabled}
          title={title}
        >
          <span
            className="material-symbols-outlined fw-500"
            style={{ lineHeight: "21px" }}
          >
            {icon ? icon : "add_circle"}
          </span>
          <div className="remove-text-on-925px" style={{ lineHeight: "21px" }}>
            {name ? name : "Add"}
          </div>
        </Button>
      );
    } else if (type === "dropdownBtn") {
      return (
        <Button
          btnStyle="default"
          size="small"
          className="lightbutton-btn"
          onClick={addOnClick}
        >
          <div className="remove-text-on-925px" style={{ lineHeight: "21px" }}>
            Add
          </div>
          <span
            className="material-symbols-outlined fw-500"
            style={{
              lineHeight: "21px",
              marginLeft: "10px",
              marginRight: "0px",
            }}
          >
            keyboard_arrow_down
          </span>
        </Button>
      );
    } else if (type === "backIconBtn") {
      return (
        <Button
          className="backBtn iconBtn"
          btnStyle="link"
          type={btnType}
          onClick={onClick}
          {...props}
        >
          {isLoading ? (
            <Spinner
              style={{
                height: "3px",
                marginTop: "-15px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
          ) : (
            <React.Fragment>
              <span className="material-symbols-outlined backBtn-arrow-back btn-icon">
                west
              </span>
              {btnTitle}
            </React.Fragment>
          )}
        </Button>
      );
    } else if (type === "nextIconBtn") {
      return (
        <Button
          className="btn-next"
          btnStyle={btnStyle}
          type={btnType}
          disabled={disabled}
          {...props}
        >
          {isLoading ? (
            <Spinner
              style={{
                height: "3px",
                marginTop: "-15px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
          ) : (
            <React.Fragment>
              {btnTitle}
              <span className="material-symbols-outlined nextBtn-arrow-forward btn-icon">
                east
              </span>
            </React.Fragment>
          )}
        </Button>
      );
    } else if (type === "iconPrimaryBtn") {
      return (
        <Button
          btnStyle={btnStyle}
          type={btnType}
          onClick={onClick ? onClick : OnClick}
          size={"small"}
          icon={"check-circle"}
          style={{
            background: "#0161ED",
            color: "#fff",
            padding: "9px 12px",
            marginLeft: '5px',
            ...style,
          }}
          {...props}
        >
          {children}
        </Button>
      );
    } else if (type === "iconSecondaryBtn") {
      return (
        <Button
          btnStyle={"danger"}
          type={btnType}
          onClick={onClick ? onClick : OnClick}
          size={"small"}
          icon={"refresh"}
          style={{
            marginLeft: "5px",
            background: "#EA475D",
            color: "#fff",
            padding: "9px 12px",
            ...style,
          }}
          {...props}
        >
          {children}
        </Button>
      );
    } else if (type === "blueModalBtn") {
      return (
        <Button
          className={`blue-btn ${className}`}
          btnStyle={btnStyle}
          type={btnType}
          onClick={onClick ? onClick : OnClick}
          disabled={disabled}
          size={size}
          style={{
            float: "right",
            textTransform: "uppercase",
            ...style,
          }}
          {...props}
        >
          {isLoading ? (
            <Spinner
              style={{
                height: "3px",
                marginTop: "-15px",
                padding: "10px",
                marginBottom: "10px",
              }}
            />
          ) : modalBtnTitle ? (
            modalBtnTitle
          ) : (
            children
          )}
        </Button>
      );
    } else if (type === "greyModalBtn") {
      return (
        <Button
          className={`grey-btn ${className}`}
          btnStyle={btnStyle}
          type={btnType}
          size={size}
          onClick={onClick ? onClick : OnClick}
          style={{
            float: "left",
            textTransform: "uppercase",
            ...style,
          }}
          {...props}
        >
          {modalBtnTitle ? modalBtnTitle : children}
        </Button>
      );
    } else if (type === "deleteAll") {
      return (
        <Button
          btnStyle="danger"
          size="small"
          className="redbutton-btn"
          onClick={checkboxDeleteOnClick}
        >
          <span className="material-symbols-outlined">delete</span>
          <div className="remove-text-on-925px">Delete</div>
        </Button>
      );
    } else if (type === "edit") {
      return (
        <Tip text={`${"Edit "}`} key={`${"Edit "}`}>
          <Button
            className="fvs-normal"
            disabled={props.disabled}
            btnStyle="link"
            onClick={editOnClick || onClick}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "18px" }}
            >
              edit
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "view") {
      return (
        <Tip text={`${"View "}`} key={`${"View "}`}>
          <Button disabled={props.disabled} btnStyle="link" onClick={onClick}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "18px" }}
            >
              visibility
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "manageAgent") {
      return (
        <Tip text={`${"Manage Agents"}`} key={`${"Manage Agents"}`}>
          <Button btnStyle="link" onClick={manageAgentOnClick} size="large">
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              person_add
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "manageTeamLeader") {
      return (
        <Tip text={`${"Manage Team Leader"}`} key={`${"Manage Team Leader"}`}>
          <Button
            btnStyle="link"
            onClick={manageTeamLeaderOnClick}
            size="large"
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              group_add
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "delete") {
      return (
        <Tip text={`${"Delete"}`} key={`${"Delete"}`}>
          <Button btnStyle="link" onClick={deleteOnClick} disabled={disabled}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              delete
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "checkboxDelete") {
      return (
        <Button
          btnStyle="danger"
          size="small"
          className="redbutton-btn"
          onClick={checkboxDeleteOnClick}
          disabled={disabled}
        >
          <span className="material-symbols-outlined">delete</span>
          <span className="remove-text-on-925px"> Delete </span>
        </Button>
      );
    } else if (type === "defaultPhoneNumbers") {
      return (
        <Tip text={`${"Default Phone Number"}`} key={`${"setDefault"}`}>
          <Button
            btnStyle="link"
            onClick={defaultPhonenumberOnClick}
          // icon="phone"
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              call
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "rate") {
      return (
        <Tip text={`${"Rate"}`} key={`${"Rate"}`}>
          <Link to={rateTo} style={{ color: "rgb(136, 136, 136)" }}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              list
            </span>
          </Link>
        </Tip>
      );
    } else if (type === "infoBtn") {
      return (
        <Tip text={`${"Info"}`} key={`${"Info"}`}>
          <Button btnStyle="link" onClick={infoOnClick}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              info
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "playIcon") {
      return (
        <Tip text={`${"Play"}`} key={`${"Play"}`}>
          <img src="/images/Play.png" width="" height="50" alt="Play"></img>
        </Tip>
      );
    } else if (type === "pauseIcon") {
      return (
        <Tip text={`${"Pause"}`} key={`${"Pause"}`}>
          <img src="/images/Pause.png" width="" height="50" alt="Pause"></img>
        </Tip>
      );
    } else if (type === "playButton") {
      return (
        <Tip text={`${"Play"}`} key={`${"Play"}`}>
          <Button
            btnStyle="simple"
            style={{
              verticalAlign: "middle",
              padding: "5px 10px",
              color: "#2B3C93",
              border: "1px solid #f2f2f2",
              background: "#fff",
              fontWeight: "500",
            }}
            onClick={playButtonOnClick}
          >
            <span className="material-symbols-outlined">play_arrow</span>
          </Button>
        </Tip>
      );
    } else if (type === "pauseButton") {
      return (
        <Tip text={`${"Pause"}`} key={`${"Pause"}`}>
          <Button
            btnStyle="simple"
            style={{
              verticalAlign: "middle",
              padding: "5px 10px",
              color: "#2B3C93",
              border: "1px solid #f2f2f2",
              background: "#fff",
              fontWeight: "500",
            }}
            onClick={pauseButtonOnClick}
          >
            <span className="material-symbols-outlined">pause</span>
          </Button>
        </Tip>
      );
    } else if (type === "editLink") {
      return (
        <Tip text="Edit" key="edit">
          <Link to={editLink} className="lh-1">
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              edit
            </span>
          </Link>
        </Tip>
      );
    } else if (type === "churnContact") {
      return (
        <Tip text="Churn Contact" key="churn">
          <Button btnStyle="link" onClick={churnContactOnClick} style={{}}>
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              settings_backup_restore
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "manageCampaign") {
      return (
        <Tip text="Manage Contact List" key="Manage Contact List">
          <Button
            btnStyle="link"
            onClick={manageCampaignOnClick}
            style={{}}
          // icon="edit"
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px" }}
            >
              contacts
            </span>
          </Button>
        </Tip>
      );
    } else if (type === "importExportDownload") {
      return (
        <Tip text="Download" key="Download">
          <Button onClick={importExportDownloadOnClick} style={{ ...style }} disabled={disabled}>
            <span className="material-symbols-outlined">download</span>
          </Button>
        </Tip>
      );
    } else if (type === "addLink") {
      return (
        <Link to={addLink}>
          <Button btnStyle="default" size="small" className="lightbutton-btn">
            <span className="material-symbols-outlined">Add_circle</span>
            <div>Add</div>
          </Button>
        </Link>
      );
    } else if (type === "pauseLinkButton") {
      return (
        <Tip text="Pause" key="Pause">
          <Button btnStyle="link" onClick={pauseLinkButtonOnClick}>
            <span className="material-symbols-outlined">pause_circle</span>
          </Button>
        </Tip>
      );
    } else if (type === "playLinkButton") {
      return (
        <Tip text="Set live" key="Set live">
          <Button btnStyle="link" onClick={playLinkButtonOnClick}>
            <span className="material-symbols-outlined">play_circle</span>
          </Button>
        </Tip>
      );
    } else if (type === "countCampaign") {
      return (
        <Tip text="Remaining Count" key="Count">
          <Button
            btnStyle="link"
            onClick={countCampaignOnClick}
            className="d-flex align-items-center"
            style={{ paddingLeft: "0px" }}
          >
            <span className="material-symbols-outlined">restart_alt</span>
            {countCampaignValue}
          </Button>
        </Tip>
      );
    } else if (type === "removeLinkBtn") {
      return (
        <Button btnStyle="link" size="medium" onClick={removeLinkBtnOnClick}>
          <span className="material-symbols-outlined">cancel</span>
        </Button>
      );
    } else if (type === "addLinkBtn") {
      return (
        <Button
          onClick={addLinkBtnOnClick}
          btnStyle="default"
          size="small"
          className="lightbutton-btn"
        >
          <span className="material-symbols-outlined">add_circle</span>
          <div>Add</div>
        </Button>
      );
    } else if (type === "integrationLink") {
      return (
        <Link to={integrationLink}>
          <div>Configure</div>
        </Link>
      );
    } else if (type === "clearChatLink") {
      return (
        <Button
          btnStyle="link"
          size="small"
          // onClick={removeLinkBtnOnClick}
          onClick={onClick}
          style={{ padding: "12px 6px" }}
        >
          <span class="material-symbols-outlined">delete</span>
        </Button>
      );
    }
    return <Button>No Such Button of type {type} Was found</Button>;
  }
}

export default ButtonCommonTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ButtonCommonTheme.js